<template>
  <div class="t-success" :class="props.class">
    <svg width="99" height="99" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="49.5" cy="49.5" r="49.5" fill="#ED8E8E" />
      <path d="M33.1484 66L65.1484 34" stroke="white" stroke-width="5" stroke-linejoin="round" />
      <path d="M65 66L33 34" stroke="white" stroke-width="5" stroke-linejoin="round" />
    </svg>
    <h3 class="t-success__title">{{ props.title }}</h3>
    <div class="t-success__text _error">{{ props.text }}</div>
    <div class="t-success__row">
      <a v-if="props.btnEvent" v-link href="/events" @click="modalClose" class="t-btn _back t-success__btn _events">{{
        props.btnEvent
      }}</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: ['props'],
  methods: {
    ...mapActions('modal', ['modalClose']),
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/error.vue